<template>
  <div class="soe-page">
    <!-- ============ 品牌头部 ============ -->
    <header class="sub-header">
      <div class="sub-header-inner">
        <button type="button" class="back-btn" aria-label="返回" @click="goBack">
          <van-icon name="arrow-left" />
        </button>
        <h1 class="sub-title">假央企名单</h1>
        <span class="sub-right" v-if="ready">共 {{ total || 0 }} 家</span>
      </div>
    </header>

    <main class="page-content">
      <!-- 查询框 -->
      <div class="search-area">
        <div class="search-field">
          <van-icon name="search" class="s-icon" />
          <input v-model="keyword"
                 type="text"
                 placeholder="输入名称 / 编码查询"
                 @input="onKw" />
          <button v-if="keyword" type="button" class="clear-btn" aria-label="清空" @click="clearKw">
            <van-icon name="close" />
          </button>
        </div>
      </div>

      <!-- 首屏加载骨架 -->
      <div class="soe-skeleton" v-if="!ready">
        <van-skeleton title :row="8" />
      </div>

      <!-- 列表 -->
      <section v-else-if="list.length" class="soe-list-section">
        <ul class="soe-list">
          <li v-for="item in list" :key="item.id" class="soe-row">
            <span class="soe-dot"></span>
            <div class="soe-main">
              <h3>{{ item.companyName }}</h3>
              <div class="soe-chips" v-if="extraTags(item.labels).length">
                <span v-for="(t, ti) in extraTags(item.labels)" :key="ti" class="chip">{{ t }}</span>
              </div>
              <p class="soe-time" v-if="formatTime(item.createTime)">{{ formatTime(item.createTime) }} 收录</p>
            </div>
          </li>
        </ul>

        <!-- 加载更多 / 到底 -->
        <div class="list-more" v-if="loading || (finished && list.length)">
          <van-loading v-if="loading" size="18px" color="#ef4f16">正在加载更多…</van-loading>
          <span v-else class="list-end">已经到底了</span>
        </div>
      </section>

      <!-- 空态 -->
      <div v-else class="soe-empty">
        <van-icon name="search" />
        <p>{{ keyword ? '未匹配到相关企业，换个名称试试' : '暂无涉假企业收录' }}</p>
      </div>
    </main>
  </div>
</template>

<script>
import guoqiShare from '../utils/guoqiShare'
import pageAccess from '../utils/pageAccess'
export default {
  name: 'guoqiSoe',
  mixins: [guoqiShare, pageAccess],
  data () {
    return {
      // 页面访问日志：页面名称
      pageName: '假央企名单',
      // 微信分享：链接为当前路由
      shareTitle: '假央企名单：涉假企业实时查询',
      shareDesc: '收录国资委通报的涉假央企、假国企名单，支持企业名称与统一社会信用代码查询',
      keyword: '',
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      finished: false,
      ready: false,
      kwTimer: null
    }
  },
  created () {
    this.getList()
  },
  mounted () {
    window.onscroll = this.onScroll
  },
  beforeDestroy () {
    window.onscroll = null
    clearTimeout(this.kwTimer)
  },
  methods: {
    goBack () {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/guoqi')
      }
    },
    // 触底加载下一页（与资讯页分页一致）
    onScroll () {
      if (this.loading || this.finished) return
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollHeight - scrollTop - windowHeight < 80) {
        this.pageNum += 1
        this.getList()
      }
    },
    onKw () {
      clearTimeout(this.kwTimer)
      this.kwTimer = setTimeout(() => {
        this.reload()
      }, 300)
    },
    clearKw () {
      this.keyword = ''
      this.reload()
    },
    reload () {
      this.pageNum = 1
      this.list = []
      this.finished = false
      this.total = 0
      this.ready = false
      this.getList()
    },
    // 假央企名单：labels 含“假央企”的黑名单记录，分页加载
    getList () {
      if (this.loading || this.finished) return
      this.loading = true
      const kw = this.keyword.trim().toLowerCase()
      this.$api.post('/api/crm/blackList/list', {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        data: {},
        params: {
          companyName$LIKE: kw,
          'labels$LIKE': '假央企'
        }
      }).then((res) => {
        if (res && res.result) {
          const raw = res.result.list || []
          this.total = res.result.total || 0
          const existed = {}
          this.list.forEach((item) => { if (item.id != null) existed[item.id] = true })
          const fresh = raw.filter((item) => item && item.id != null && !existed[item.id])
          this.list = this.list.concat(fresh)
          if (raw.length < this.pageSize || (this.total > 0 && this.list.length >= this.total)) {
            this.finished = true
          }
        } else {
          this.finished = true
        }
      }).then(() => {
        this.loading = false
        this.ready = true
      })
    },
    // labels 可能是数组或逗号/顿号分隔字符串，剔除“假央企”字面
    extraTags (labels) {
      const arr = Array.isArray(labels) ? labels : String(labels || '').split(/[,，、;；/]/)
      return arr.map((s) => String(s).trim()).filter((s) => s && s !== '假央企')
    },
    // createTime 可能是时间戳或日期字符串，统一展示为“yyyy-MM-dd HH:mm”
    formatTime (v) {
      if (!v) return ''
      const str = String(v).trim()
      if (/^\d{10,}$/.test(str)) {
        const ts = str.length === 10 ? Number(str) * 1000 : Number(str)
        const d = new Date(ts)
        if (!isNaN(d.getTime())) {
          const p = (n) => String(n).padStart(2, '0')
          return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
        }
      }
      return str.length > 16 ? str.slice(0, 16) : str
    }
  }
}
</script>

<style lang="less" scoped>
@page-bg: #faf7f1;
@surface: #fffdfc;
@ink: #142033;
@body: #333a45;
@muted: #7f858d;
@brand: #ef4f16;
@brand-light: #f47a3c;
@brand-soft: #fff1e8;
@gold: #d7a34a;
@line: #e9e6e1;

button { margin: 0; padding: 0; border: 0; color: inherit; font: inherit; background: transparent; appearance: none; }
ul { margin: 0; padding: 0; list-style: none; }

.soe-page { min-height: 100vh; box-sizing: border-box; color: @ink; background: @page-bg; font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif; }

/* ================= 品牌头部 ================= */
.sub-header { position: sticky; top: 0; z-index: 20; background: rgba(250, 247, 241, 0.94); backdrop-filter: blur(6px); -webkit-backdrop-filter: blur(6px); border-bottom: 1px solid @line; }
.sub-header-inner { position: relative; display: flex; align-items: center; max-width: 750px; height: 88px; margin: 0 auto; padding: 0 24px; box-sizing: border-box; }
.back-btn { display: inline-flex; align-items: center; justify-content: center; width: 60px; height: 60px; color: @ink; cursor: pointer; }
.back-btn .van-icon { font-size: 38px; }
.sub-title { position: absolute; right: 24px; left: 24px; margin: 0; color: @ink; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 34px; font-weight: 700; letter-spacing: 1px; line-height: 88px; text-align: center; pointer-events: none; }
.sub-right { position: absolute; right: 24px; color: @muted; font-size: 21px; }

/* ================= 页面主体 ================= */
.page-content { max-width: 750px; margin: 0 auto; padding: 0 0 56px; }

/* ================= 查询框 ================= */
.search-area { padding: 28px 40px 6px; }
.search-field { display: flex; align-items: center; box-sizing: border-box; height: 62px; padding: 0 22px; background: @surface; border: 1px solid @line; border-radius: 31px; box-shadow: 0 4px 12px rgba(20, 32, 51, 0.04); }
.s-icon { flex: 0 0 auto; color: @muted; font-size: 28px; }
.search-field input { flex: 1; min-width: 0; height: 100%; margin-left: 12px; border: none; outline: none; background: transparent; color: @ink; font-family: inherit; font-size: 26px; }
.search-field input::placeholder { color: #a9aeb5; }
.clear-btn { display: inline-flex; align-items: center; justify-content: center; width: 52px; height: 52px; color: #a9aeb5; cursor: pointer; }
.clear-btn .van-icon { font-size: 26px; }
.search-hint { margin: 14px 4px 0; color: @muted; font-size: 20px; }

/* ================= 列表 ================= */
.soe-skeleton { padding: 10px 40px; }
.soe-list-section { margin-top: 22px; padding: 0 40px; background: @surface; border-top: 1px solid @line; border-bottom: 1px solid @line; }
.soe-row { position: relative; display: flex; align-items: flex-start; padding: 28px 0; }
.soe-row::after { position: absolute; right: 0; bottom: 0; left: 0; height: 1px; background: @line; content: ""; }
.soe-row:last-child::after { display: none; }
.soe-dot { flex: 0 0 auto; width: 10px; height: 10px; margin: 13px 20px 0 0; border-radius: 50%; background: @brand; }
.soe-main { flex: 1; min-width: 0; }
.soe-main h3 { margin: 0; color: @ink; font-size: 29px; font-weight: 700; line-height: 1.5; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
.soe-chips { display: flex; flex-wrap: wrap; gap: 12px; margin-top: 14px; }
.chip { color: @brand; background: @brand-soft; font-size: 20px; font-weight: 500; padding: 6px 16px; border-radius: 999px; }
.soe-time { margin: 12px 0 0; color: @muted; font-size: 20px; }

.list-more { display: flex; align-items: center; justify-content: center; min-height: 92px; box-sizing: border-box; padding: 10px 0 22px; color: #a9aeb5; font-size: 20px; }
.list-end { position: relative; padding: 0 28px; }
.list-end::before, .list-end::after { position: absolute; top: 50%; width: 64px; height: 1px; background: @line; content: ""; transform: translateY(-50%); }
.list-end::before { right: 100%; }
.list-end::after { left: 100%; }

/* ================= 空态 ================= */
.soe-empty { margin: 30px 40px 0; padding: 70px 0; text-align: center; color: @muted; background: @surface; border-top: 1px solid @line; border-bottom: 1px solid @line; }
.soe-empty .van-icon { font-size: 44px; }
.soe-empty p { margin: 16px 0 0; font-size: 24px; }

@media (max-width: 420px) {
  .sub-header-inner { height: 78px; padding: 0 14px; }
  .sub-title { right: 14px; left: 14px; font-size: 30px; line-height: 78px; }
  .sub-right { right: 14px; font-size: 17px; }
  .search-area { padding: 22px 22px 4px; }
  .soe-skeleton { padding: 8px 22px; }
  .soe-list-section { padding: 0 22px; }
  .soe-main h3 { font-size: 25px; }
  .chip { font-size: 17px; padding: 4px 12px; }
  .soe-time { font-size: 17px; }
  .soe-empty { margin-right: 22px; margin-left: 22px; }
  .soe-empty p { font-size: 21px; }
}
</style>
